import BossModel from "@/models/BossModel";

export default class Day extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'product/discount/day';

    /**
     *
     * @type {string}
     */
    static entity = 'productDiscountDays';

    static fields() {
        return {
            id: this.number(null).nullable(),
            product_discount_id: this.number(null).nullable(),
            day_of_week: this.number(null).nullable(),
            created_at: this.attr(null),
        }
    }
}
